import type { DeviceState } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/device';

export const PLATFORM = {
  MWEB: 'MWeb',
  DESKTOP: 'Desktop',
  TABLET: 'Tablet',
} as const;

/**
 * @param {DeviceState} device A representation of the traveller's device as determined by DeviceAtlas
 * @returns {'MWeb' | 'Tablet' | 'Desktop'} Enums used within Banana codebase to represent the type of platform
 */
export const getPlatform = (device: DeviceState): (typeof PLATFORM)[keyof typeof PLATFORM] => {
  if (device.isMobilePhone) {
    return PLATFORM.MWEB;
  }

  if (device.isTablet) {
    return PLATFORM.TABLET;
  }

  return PLATFORM.DESKTOP;
};
